export function shouldSubmitComposerOnKeyDown(input: {
  key: string;
  shiftKey: boolean;
  altKey: boolean;
  ctrlKey: boolean;
  metaKey: boolean;
  isComposing: boolean;
  keyCode: number;
  canSubmit: boolean;
}): boolean {
  if (!input.canSubmit) return false;
  if (input.isComposing || input.keyCode === 229) return false;
  if (input.key !== "Enter") return false;
  if (input.shiftKey || input.altKey || input.ctrlKey || input.metaKey) return false;
  return true;
}
